export const redirectToLogin = () => {
  if (window?.casaHelperUtils?.handleLogOut)
    window?.casaHelperUtils?.handleLogOut();
  else console.error("unable to redirect to login");
};
